import { QuestionModel } from '@/modules/core/domain/interfaces/IFormulary';
import useField from '@/modules/WebForm/hooks/useField';
import { createAnswer } from '@/modules/WebForm/utils';
import {
  Badge,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import FormControlComponent from '../FormControlComponent';

const CheckboxContent: React.FC<QuestionModel> = ({ options }) => {
  const { error, onChange, fieldState } = useField();

  const value = React.useMemo(() => {
    if (fieldState) {
      if (Array.isArray(fieldState)) {
        return fieldState;
      }
      return [fieldState];
    }
    return [];
  }, [fieldState]);

  const handleChange = React.useCallback(
    (id: string, checked: boolean) => {
      if (checked) {
        onChange([...value, createAnswer(id)]);
      } else {
        onChange(value.filter((a) => a.content !== id));
      }
    },
    [onChange, value],
  );

  const handleSelectAll = React.useCallback(() => {
    const allSelected = options.length === value.length;
    if (allSelected) {
      onChange([]);
    } else {
      onChange(options.map((o) => createAnswer(o.id)));
    }
  }, [onChange, options, value]);

  const allSelected = options.length === value.length;

  return (
    <Flex>
      <FormControlComponent isInvalid={error}>
        <VStack alignItems="flex-start" spacing={3} width="100%">
          <CheckboxGroup
            colorScheme="brand"
            value={value.map((o) => o.content)}
          >
            <VStack alignItems="flex-start">
              {options.map((o) => {
                const isChecked = !!value.find((a) => a.content === o.id);
                return (
                  <VStack alignItems="flex-start" key={o.id}>
                    <Checkbox
                      onChange={(e) => handleChange(o.id, e.target.checked)}
                      value={o.id}
                      isChecked={isChecked}
                      translate="no"
                    >
                      {o.name}
                    </Checkbox>
                    {o.alertMessage && isChecked && (
                      <Badge
                        rounded="md"
                        w="min-content"
                        fontSize="md"
                        fontWeight="bold"
                        colorScheme="orange"
                        variant="outline"
                        translate="no"
                      >
                        {o.alertMessage}
                      </Badge>
                    )}
                  </VStack>
                );
              })}
            </VStack>
          </CheckboxGroup>
          <Button
            size="sm"
            colorScheme="brand"
            onClick={handleSelectAll}
            alignSelf="flex-end"
          >
            {allSelected ? 'Desmarcar todos' : 'Selecionar todos'}
          </Button>
        </VStack>
      </FormControlComponent>
    </Flex>
  );
};

export default CheckboxContent;
